/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';


export const CHECKPOOLEDACCOUNTDETAIL_GQL = gql`
  query CheckPooledAccounts {
    checkPooledAccounts {
        hasPooledAccounts
    }
  }
`;

export const useCheckPooledAccountDetails = () => {
  
  const session = useSessionContext()
  const { loading, error, data } = useQuery(CHECKPOOLEDACCOUNTDETAIL_GQL,{
    fetchPolicy: "network-only",
    skip: session.roles?.[0] != 'TD_BANK_USER',
     context:{
            clientName:"/secure-storage/manage"
        }
  });

  return { error, loading, checkPooledAccountDetail: data };
};